import { useState } from "react";
import api from "../utils/api/authApi";
import { WAREHOUSE_SHOPPING_LIST } from "../enums/ApiPaths";
import logger from "../utils/logger";

// Downloads the shopping list PDF - same axios + blob + anchor-download
// recipe as useDownloadWarehouseLabelsBatch (useWarehouseItemQrCode.jsx),
// kept in its own file since it isn't QR/label related.
export function useDownloadWarehouseShoppingList() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const downloadShoppingList = async (items, captions) => {
    if (!items || items.length === 0) return false;

    setIsLoading(true);
    setError(null);

    try {
      const response = await api.post(
        WAREHOUSE_SHOPPING_LIST,
        {
          items: items.map(({ itemId, quantity }) => ({ itemId, quantity })),
          captions,
        },
        {
          responseType: "blob",
        },
      );

      if (response.status === 200) {
        const blob = response.data;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "warehouse-shopping-list.pdf");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
      }

      return true;
    } catch (err) {
      logger.error("Failed to download warehouse shopping list:", err);
      setError(err);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { downloadShoppingList, isLoading, error };
}
